import React from "react";
import classes from "./categoryFilter.module.css";

const CategoryFilter = (props) => {
  const {
    categories, selectedCategoryId, setSelectedCategoryId 
  } = props;

  const items = categories.map((category) => {
    const itemClass =
            selectedCategoryId === category.ids
              ? classes.activeCategoryItem
              : classes.categoryItem;

    return (
      <div
        className={itemClass}
        key={category.ids}
        onClick={() => setSelectedCategoryId(category.ids)}
      >
        {category.label}
      </div>
    );
  });

  return (
    <div className={classes.root}>
      <div
        className={
          selectedCategoryId === ""
            ? classes.activeCategoryItem
            : classes.categoryItem
        }
        onClick={() => setSelectedCategoryId("")}
      >
                All
      </div>
      {items}
    </div>
  );
};

export default CategoryFilter;
